import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Button } from 'primereact/button';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import utils from '../../../../../utils/utils';
import { user } from '../../../../../redux/user';
import { PERMISSION as PERMISSIONS } from '../../../../../constants';
import actionsIcon from '../../../../../assets/images/edit-icon-purple.svg';
import UploadGenericCredentialModal from '../../../../../components/modals/UploadCredentialModal/UploadGenericCredentialModal';
import {
	useFlexCredentialByTypeQuery,
	useEditFlexCredentialMutation
} from '../../../../../redux/flex-professional-credentials';
import UploadPLCredentialModal from '../../../../../components/modals/UploadCredentialModal/UploadPLCredentialModal';

const FlexCredentialsEditAction = ({
	managementCompanyId,
	caregiverId,
	rowData,
	credentialType,
	enabledCredentials,
	DownloadButton,
	onSuccess = () => {}
}) => {
	const userData = useSelector(user, shallowEqual);

	const [credentialTypeCode, setCredentialTypeCode] = useState('');
	const [showUploadGenericModal, setShowUploadGenericModal] = useState(false);
	const [showUploadPL, setShowUploadPL] = useState(false);

	const hasEditPermission = utils.isAuthorizedExact(
		PERMISSIONS.WORKFORCE_CREDENTIALS_EDIT,
		userData.managementCompanyPermissions[managementCompanyId]
	);

	const onEditClick = () => {
		if (credentialType === 'PROFESSIONAL_LICENSE') {
			setShowUploadPL(true);
		} else {
			setShowUploadGenericModal(true);
			setCredentialTypeCode(credentialType);
		}
	};

	if (!hasEditPermission) {
		// eslint-disable-next-line react/jsx-no-useless-fragment
		return <></>;
	}

	return [
		<OverlayTrigger
			placement="bottom-end"
			key="edit-button"
			trigger={['hover']}
			overlay={<Tooltip className="download-permission-tooltip">Edit credential</Tooltip>}
		>
			<Button type="button" className="btn actions" onClick={onEditClick} aria-controls="popup_menu_left" aria-haspopup>
				<img src={actionsIcon} alt="upload" />
			</Button>
		</OverlayTrigger>,

		showUploadGenericModal && (
			<UploadGenericCredentialModal
				key="genereic-upload-modal"
				credentialType={credentialTypeCode}
				caregiverId={caregiverId}
				managementCompanyId={managementCompanyId}
				enabledCredentials={enabledCredentials}
				credentialData={rowData}
				uploadCredentialMutation={useEditFlexCredentialMutation}
				credentialByTypeQuery={useFlexCredentialByTypeQuery}
				onClose={() => {
					setShowUploadGenericModal(false);
				}}
				isAttachmentRequired={false}
				DownloadButton={DownloadButton}
			/>
		),

		showUploadPL && (
			<UploadPLCredentialModal
				key="pl-upload-modal"
				caregiverId={caregiverId}
				managementCompanyId={managementCompanyId}
				credentialData={rowData}
				uploadCredentialMutation={useEditFlexCredentialMutation}
				credentialByTypeQuery={useFlexCredentialByTypeQuery}
				onClose={() => setShowUploadPL(false)}
				onSuccess={onSuccess}
				DownloadButton={DownloadButton}
			/>
		)
	];
};

export default FlexCredentialsEditAction;
